import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=6162c7a3&scoped=true&lang=pug&"
import script from "./Servicos.vue?vue&type=script&lang=js&"
export * from "./Servicos.vue?vue&type=script&lang=js&"
import style0 from "./Servicos.styl?vue&type=style&index=0&id=6162c7a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162c7a3",
  null
  
)

export default component.exports